function easeInOutQuart(x: number): number {
    if (x > 1) {
        return 1
    }
    return x < 0.5 ? 8 * x * x * x * x : 1 - window.Math.pow(-2 * x + 2, 4) / 2
}

const formatter = new Intl.NumberFormat()

export class StatCard {
    private type: string = 'number'
    private readonly countFrom: number
    private readonly countTo: number
    private readonly showPercentage: boolean

    private durationInSeconds: number = 3

    private get difference(): number {
        return this.countFrom - this.countTo
    }

    private currentValue: number
    private start: number = 0

    private get direction(): 'UP' | 'DOWN' {
        return this.difference < 0 ? 'UP' : 'DOWN'
    }

    private intersectionObserver: IntersectionObserver

    constructor(private el: HTMLElement) {
        const { type, countFrom, countTo, showPercentage } = this.el.dataset
        this.type = type || 'number'
        this.countFrom = countFrom ? parseInt(countFrom, 10) : 0
        this.currentValue = this.countFrom
        this.countTo = countTo ? parseInt(countTo, 10) : 100
        this.showPercentage = showPercentage === 'yes'
        this.intersectionObserver = new IntersectionObserver(([element]) => {
            const ratio = element.intersectionRatio * 100

            if (ratio >= 90 && ! this.isFinished()) {
                this.start = performance.now()
                requestAnimationFrame(this.countUp.bind(this))
            } else if (ratio <= 10 && this.isFinished()) {
                // requestAnimationFrame(this.countDown.bind(this));
            }
        }, { threshold: [1, 0.9, 0.1, 0] })
        this.intersectionObserver.observe(this.el)
    }

    countUp() {
        if (this.isFinished()) {
            return
        }
        const mathFn = this.direction === 'UP' ? Math.min : Math.max
        const now = performance.now()
        const progress = (now - this.start) / (this.durationInSeconds * 1000)
        this.currentValue = this.countFrom - (easeInOutQuart(progress) * this.difference)
        const value = Math.round(mathFn(this.currentValue, this.countTo))
        let innerText = value.toString()

        if (this.type === 'number') {
            innerText = formatter.format(value)

            if (this.showPercentage) {
                innerText = innerText + '%'
            }
        }

        this.el.innerText = innerText
        if (! this.isFinished()) {
            requestAnimationFrame(this.countUp.bind(this))
        }
    }

    countDown() {
        this.currentValue = this.countFrom
        this.el.innerText = this.currentValue.toString()
    }

    isFinished() {
        return (this.direction === 'UP' && this.currentValue >= this.countTo)
            || (this.direction === 'DOWN' && this.currentValue <= this.countTo)
    }
}
